export { WishlistPage } from './WishlistPage';
